"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("intersection-observer");
var js_util_1 = require("@giphy/js-util");
var carousel_1 = require("./components/carousel");
exports.Carousel = carousel_1.default;
var attribution_1 = require("./components/attribution");
exports.Attribution = attribution_1.default;
var overlay_1 = require("./components/attribution/overlay");
exports.AttributionOverlay = overlay_1.default;
var gif_1 = require("./components/gif");
exports.Gif = gif_1.default;
var grid_1 = require("./components/grid");
exports.Grid = grid_1.default;
var version = require('../package.json').version;
// send headers with library type and version
js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-NAME", 'ReactSDK');
js_util_1.appendGiphySDKRequestHeader("X-GIPHY-SDK-VERSION", version);
//# sourceMappingURL=index.js.map